import { render } from "./InputPhoneNumber.vue?vue&type=template&id=990b95c4&scoped=true"
import script from "./InputPhoneNumber.vue?vue&type=script&lang=ts"
export * from "./InputPhoneNumber.vue?vue&type=script&lang=ts"

import "./InputPhoneNumber.vue?vue&type=style&index=0&id=990b95c4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-990b95c4"

export default script